import '@types/telegram-web-app/index.d.ts';

export function getWebApp() {
  return window.Telegram.WebApp;
}
